module.exports = __webpack_public_path__ + "static/media/welcome-banner.dc585284.png";